<template>
	<!-- 入库 -->
	<div class="no-group">
		<!-- 表格 -->
		<div class="group-content">
			<div class="group-title">患者管理 _申请退回</div>
			<div class="model-type">
				<span>确认申请退回吗？</span>
			</div>
			<div>
				<textarea :class="isVerifyRemark?'isErr':''" @focus="focusRemark" placeholder="请输入原因......"
				          v-model="verifyRemark" cols="30"
				          rows="10"></textarea>
				<div class="help-line" v-show="isVerifyRemark">
					<span>请输入申请退回愿意</span>
				</div>
			</div>
			<div class="wei_des">
				附件说明：
				<a-upload name="file" :remove="handleRemove" :beforeUpload="beforeUpload"
				          :multiple="false">
					<a-button>
						选择文件
					</a-button>
				</a-upload>
			</div>
			<div style="margin-top:10px">
				<a-button type="primary" @click="sure()" :loading="isHttpSubmit" style="margin-right:16px;">确定
				</a-button>
				<a-button @click="cancel()">取消</a-button>
			</div>
		</div>
	</div>

</template>

<script>
  export default {
    props: ['review'],
    data() {
      return {
        verifyRemark: '',
        isVerifyRemark: false,
        disabled: false,
        isHttpSubmit: false,
        fileList: null,
      };
    },
    created() {

    },
    mounted() {
    },
    methods: {
      cancel() {
        this.$emit('close')
      },
      handleRemove(file) {
        this.fileList = null;
      },
      // 上传前事件
      beforeUpload(file) {
        this.fileList = file;
        return false;
      },
      focusRemark() {
        this.isVerifyRemark = false;
      },
      sure() {
        let self = this;
        this.isHttpSubmit = true;
        if (this.verifyRemark == '') {
          this.isVerifyRemark = true;
          this.isHttpSubmit = false;
        } else {
          if (this.fileList) {
            const formData = new FormData();
            formData.append("file", this.fileList);
            this.$upload("fileupload/upload", formData).then(
              res => {
                //res.data.data.certifJpgFile
                self.backReCheck(this.fileList, res.data.data.certifJpgFile);
              }, err => {
                this.isHttpSubmit = false;
              });
          } else {
            self.backReCheck({}, '');
          }

        }
      },
      backReCheck(fileData, fileUrl) {
        this.$post(
          "jobsmanage/jobs/resultBackReCheck",
          {
            fileName: fileData.name,
            fileSize: fileData.size,
            fileType: fileData.type,
            fileUrl: fileUrl,
            verifyRemark: this.verifyRemark,
            flag: 2,
            piId: this.review.id
          },
          true
        ).then(res => {
          if (res.data.code == 1) {
            this.$message.success('申请退回成功！').then(res => {
              this.$router.go(0);
            });
            this.$emit('close');
            this.$emit('update');
          } else {
            this.isHttpSubmit = false;
            this.$message.error(res.data.message)
          }
        });
      }
    }
  };
</script>
<style>
	.no-group .popup-container .header {
		height: 40px;
	}
</style>
<style lang="scss" scoped>
	.help-line {
		height: 20px;
		font-size: 12px;
		font-family: PingFang SC;
		font-weight: 400;
		color: rgba(229, 19, 19, 1);
		line-height: 20px;
	}

	.model-content {
		width: 240px;
		margin: 82px auto 0;
		text-align: left;
		.title {
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
		}

		.btn-group {
			margin-top: 25px;
			button {
				width: 100px;
			}
			button:nth-child(2) {

				margin-left: 20px;
			}
		}

	}

	.group-content {
		height: 500px;
		width: 386px;
		margin: 82px auto 0;
		.group-title {
			font-size: 26px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
			margin-bottom: 52px;
		}
		.model-type {
			font-size: 18px;
			font-family: PingFang SC;
			font-weight: 400;
			color: rgba(51, 51, 51, 1);
			margin-top: 52px;
			margin-bottom: 25px;
			span {
				display: block;
			}
			span:nth-child(2) {
				font-size: 14px;
				font-family: PingFang SC;
				font-weight: 400;
				color: rgba(164, 164, 164, 1);
			}
		}
		textarea {
			width: 386px;
			height: 202px;
			background: rgba(255, 255, 255, 1);
			border: 1px solid rgba(66, 142, 247, 1);
			padding: 10px;

		}
		.isErr {
			border: 1px solid red;
		}

	}

	.table-th {
		color: #a4a4a4;
	}

	.sure-button {
		width: 680px;
		margin: 50px auto 0;
		padding-bottom: 50px;
		.ant-btn {
			height: 42px;
		}
	}

	.wei_des {
		margin-top: 19px;
		margin-bottom: 29px;
	}
</style>